// extracted by mini-css-extract-plugin
export var headerXL = "SectionCollapsible-module--headerXL--GbZ8z";
export var headerL = "SectionCollapsible-module--headerL--3K1c-";
export var headerM = "SectionCollapsible-module--headerM--28CtU";
export var headerS = "SectionCollapsible-module--headerS--1RP65";
export var headerXS = "SectionCollapsible-module--headerXS--2O2Kr";
export var blogHeaderXL = "SectionCollapsible-module--blogHeaderXL--2g6Sh";
export var blogHeaderL = "SectionCollapsible-module--blogHeaderL--1A26q";
export var blogHeaderM = "SectionCollapsible-module--blogHeaderM--1Up-h";
export var blogHeaderS = "SectionCollapsible-module--blogHeaderS--1momu";
export var blogHeaderXS = "SectionCollapsible-module--blogHeaderXS--2ELFN";
export var headerPreamble = "SectionCollapsible-module--headerPreamble--3Eflx";
export var preHeader = "SectionCollapsible-module--preHeader--3rB5c";
export var textNormal = "SectionCollapsible-module--textNormal--jIv57";
export var textSmall = "SectionCollapsible-module--textSmall--3wQCs";
export var textSmallAlternate = "SectionCollapsible-module--textSmallAlternate--1wfwE";
export var legend = "SectionCollapsible-module--legend---9QvE";
export var caption = "SectionCollapsible-module--caption--bnN1i";
export var gradientBackground = "SectionCollapsible-module--gradientBackground--1II3i";
export var ellipsis = "SectionCollapsible-module--ellipsis--2-pGE";
export var globalContainer = "SectionCollapsible-module--globalContainer--28eXS";
export var maxWidth = "SectionCollapsible-module--maxWidth--3xZB1";
export var clipBottom = "SectionCollapsible-module--clipBottom--lWder";
export var clipTopBottom = "SectionCollapsible-module--clipTopBottom--x6IfI";
export var container = "SectionCollapsible-module--container--14CCs";
export var sectionTitle = "SectionCollapsible-module--sectionTitle--3BOTq";
export var cardTitle = "SectionCollapsible-module--cardTitle--n9fFV";
export var cardContent = "SectionCollapsible-module--cardContent--2iuZG";
export var collapseContainer = "SectionCollapsible-module--collapseContainer--1dl0t";
export var ch2 = "SectionCollapsible-module--ch2--29T-Q";
export var ch2Container = "SectionCollapsible-module--ch2-container--2IOtf";